import { useState } from "react";
import { Star } from "lucide-react";
import { api } from "../../lib/api";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime } from "../../lib/format";
import { useAdminData, SearchBox, Pager, TableCard, TH } from "./shared";

export default function AdminReviews() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminReviews);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-reviews-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search comment, listing or booking id…" testid="admin-reviews-search" />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading reviews…" /> : (
        <>
          <TableCard testid="admin-reviews-table" empty={rows.length === 0 && "No reviews found."}
            head={<><TH>Listing</TH><TH>Rating</TH><TH>Comment</TH><TH>Reviewer</TH><TH>Booking</TH><TH>Date</TH></>}>
            {rows.map((r) => (
              <tr key={r.review_id} className="border-b border-[#18181B]" data-testid={`admin-review-${r.review_id}`}>
                <td className="p-4 text-xs font-mono text-zinc-400">{r.spot_id}</td>
                <td className="p-4"><span className="text-amber-400 font-semibold flex items-center gap-1"><Star className="w-3.5 h-3.5 fill-amber-400" />{r.rating}</span></td>
                <td className="p-4 text-xs text-zinc-300 max-w-xs truncate">{r.comment || "—"}</td>
                <td className="p-4 text-xs text-zinc-400">{r.reviewer_name || "Driver"}</td>
                <td className="p-4 text-xs font-mono text-zinc-500">{r.booking_id}</td>
                <td className="p-4 text-xs text-zinc-500">{fmtDateTime(r.created_at)}</td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-reviews-pager" />
        </>
      )}
    </div>
  );
}
